import { useCallback } from "react";
import { analyticsService } from "./analyticsService";

export function useAnalytics() {
  const track = useCallback((name, properties, category = "app") => {
    // Fire-and-forget; analytics never block UX
    try { return analyticsService.track(name, category, properties || {}); } catch { /* swallow */ }
    return null;
  }, []);
  return { track, list: analyticsService.mine };
}
